import { h, createContext } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

const StorageContext = createContext();

export function StorageProvider({ children }) {
  const [bookmarks, setBookmarks] = useState(() => {
    try {
      const items = localStorage.getItem("bookmarks");
      return items ? JSON.parse(items) : [];
    } catch {
      return [];
    }
  });
  const [history, setHistory] = useState(() => {
    try {
      const items = localStorage.getItem("historyItems");
      return items ? JSON.parse(items) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    const stored = localStorage.getItem("bookmarks");
    let parsed = [];
    try {
      parsed = stored ? JSON.parse(stored) : [];
    } catch {}

    if (JSON.stringify(parsed) !== JSON.stringify(bookmarks)) {
      localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
      window.dispatchEvent(new CustomEvent("bookmarkEvent"));
    }
  }, [bookmarks]);

  useEffect(() => {
    const stored = localStorage.getItem("historyItems");
    let parsed = [];
    try {
      parsed = stored ? JSON.parse(stored) : [];
    } catch {}

    if (JSON.stringify(parsed) !== JSON.stringify(history)) {
      localStorage.setItem("historyItems", JSON.stringify(history));
      window.dispatchEvent(new CustomEvent("historyEvent"));
    }
  }, [history]);

  useEffect(() => {
    function handleStorage() {
      try {
        const b = localStorage.getItem("bookmarks");
        setBookmarks(b ? JSON.parse(b) : []);
      } catch {
        setBookmarks([]);
      }
      try {
        const h = localStorage.getItem("historyItems");
        setHistory(h ? JSON.parse(h) : []);
      } catch {
        setHistory([]);
      }
    }
    window.addEventListener("storage", handleStorage);
    window.addEventListener("bookmarkEvent", handleStorage);
    window.addEventListener("historyEvent", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("bookmarkEvent", handleStorage);
      window.removeEventListener("historyEvent", handleStorage);
    };
  }, []);

  const addBookmark = (id) =>
    setBookmarks((prev) => (prev.includes(id) ? prev : [id, ...prev]));
  const removeBookmark = (id) =>
    setBookmarks((prev) => prev.filter((item) => item !== id));
  const toggleBookmark = (id) =>
    setBookmarks((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [id, ...prev]
    );
  const clearBookmarks = () => setBookmarks([]);

  const addHistory = (id) =>
    setHistory((prev) =>
      prev.some((item) => item.id === id)
        ? prev
        : [...prev, { id, date: Date.now() }]
    );
  const removeHistory = (id) =>
    setHistory((prev) => prev.filter((item) => item.id !== id));
  const clearHistory = () => setHistory([]);

  return h(StorageContext.Provider, {
    value: {
      bookmarks,
      addBookmark,
      removeBookmark,
      toggleBookmark,
      clearBookmarks,
      history,
      addHistory,
      removeHistory,
      clearHistory,
      setBookmarks,
      setHistory,
    },
    children,
  });
}

export function useItemsStorage() {
  return useContext(StorageContext);
}
